//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Datatable from './Datatable.vue';
import Pagination from './Pagination.vue';
export default {
    components: { datatable: Datatable, pagination: Pagination },
    created: function created() {
        this.getPages();
    },
    data: function data() {
        var loading = false;
        var sortOrders = {};
        var columns = [{ class: 'col-md-3', label: 'Titel', name: 'title', type: 'text', sortable: true }, { class: 'col-md-3', label: 'URL', name: 'slug', type: 'text', sortable: true }, { class: 'col-md-3', label: 'Sprache', name: 'lang', type: 'text', sortable: true }, { class: 'col-md-3', label: '', name: 'actions', type: 'text', sortable: false }];
        columns.forEach(function (column) {
            sortOrders[column.name] = -1;
        });
        sortOrders['title'] = 1;
        return {
            permissions: [],
            pages: [],
            no_delete_slugs: [],
            columns: columns,
            sortKey: 'title',
            sortOrders: sortOrders,
            length: 10,
            search: '',
            tableData: {
                client: false
            },
            pagination: {
                currentPage: 1,
                total: '0',
                nextPage: '',
                prevPage: '',
                from: '',
                to: ''
            }
        };
    },

    methods: {
        getPages: function getPages() {
            var _this = this;

            var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/api/pages/list';

            this.loading = true;
            axios.get(url, { params: this.tableData }).then(function (response) {
                _this.loading = false;
                _this.pages = response.data.pages;
                _this.permissions = response.data.permissions;
                _this.no_delete_slugs = response.data.no_delete_slugs;
                _this.pagination.total = _this.pages.length;
            }).catch(function (errors) {
                console.log(errors);
            });
        },
        paginate: function paginate(array, length, pageNumber) {
            this.pagination.from = array.length ? (pageNumber - 1) * length + 1 : ' ';
            this.pagination.to = pageNumber * length > array.length ? array.length : pageNumber * length;
            this.pagination.prevPage = pageNumber > 1 ? pageNumber : '';
            this.pagination.nextPage = array.length > this.pagination.to ? pageNumber + 1 : '';
            return array.slice((pageNumber - 1) * length, pageNumber * length);
        },
        resetPagination: function resetPagination() {
            this.pagination.currentPage = 1;
            this.pagination.prevPage = '';
            this.pagination.nextPage = '';
        },
        sortBy: function sortBy(key) {
            this.resetPagination();
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;
        },
        getIndex: function getIndex(array, key, value) {
            return array.findIndex(function (i) {
                return i[key] == value;
            });
        }
    },
    computed: {
        filteredPages: function filteredPages() {
            var _this2 = this;

            var pages = this.pages;
            if (this.search) {
                pages = pages.filter(function (row) {
                    return Object.keys(row).some(function (key) {
                        return String(row[key]).toLowerCase().indexOf(_this2.search.toLowerCase()) > -1;
                    });
                });
            }
            var sortKey = this.sortKey;
            var order = this.sortOrders[sortKey] || 1;
            if (sortKey) {
                pages = pages.slice().sort(function (a, b) {
                    var index = _this2.getIndex(_this2.columns, 'name', sortKey);
                    a = String(a[sortKey]).toLowerCase();
                    b = String(b[sortKey]).toLowerCase();
                    if (_this2.columns[index].type && _this2.columns[index].type === 'date') {
                        return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                    } else if (_this2.columns[index].type && _this2.columns[index].type === 'number') {
                        return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                    } else {
                        return (a === b ? 0 : a > b ? 1 : -1) * order;
                    }
                });
            }
            return pages;
        },
        paginated: function paginated() {
            return this.paginate(this.filteredPages, this.length, this.pagination.currentPage);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/js/components/Pages.vue
// module id = 46
// module chunks = 0